// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"ab598a028b0d70da47ae","761":"4ec09c9cbf1743d303b2"}[chunkId] + ".js";
};